/**
 * @module 利用規約共通コンポーネント
 */
export default {
  name: 'TermView',
  components: {},
  data() {
    return {
      title: '利用規約',
    };
  },
};
